/* istanbul ignore next */
export const locationUtils = {
  getPathName: () => location.pathname,
  getOrigin: () => location.origin,
  getSearch: () => location.search,
  getHash: () => location.hash,
};

